module.exports = __webpack_public_path__ + "img/price-bg.d806dd28.svg";